<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M10.0002 4.7477V3.24707M13 4.75V3.25M7.00014 4.75V3.24707M10 16.75V15.25M13 16.75V15.25M7 16.75V15.25M15.25 13H16.75M15.25 7H16.75M15.25 10H16.75M3.25 10H4.75M3.25 13H4.75M3.25 7H4.75M12.251 10.0002C12.251 11.2434 11.2432 12.2511 10 12.2511C8.75687 12.2511 7.74909 11.2434 7.74909 10.0002C7.74909 8.75703 8.75687 7.74927 10 7.74927C11.2432 7.74927 12.251 8.75703 12.251 10.0002ZM6.25 15.25H13.75C14.5784 15.25 15.25 14.5785 15.25 13.75V6.25C15.25 5.42158 14.5784 4.75 13.75 4.75H6.25C5.42157 4.75 4.75 5.42158 4.75 6.25V13.75C4.75 14.5785 5.42157 15.25 6.25 15.25Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'SpyderTechnologyIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>